var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharelinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49557 14.7121L1.7077 14.9243L1.91983 14.7121L12.7 3.93196V10.5V10.8H13H14H14.3V10.5V1.5V1.2H14H5H4.7V1.5V2.5V2.8H5H11.568L0.787868 13.5802L0.575736 13.7923L0.787868 14.0044L1.49557 14.7121Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharelinkIcon);
export default __webpack_public_path__ + "static/media/sharelink-icon.53c809a2c2254a6c7163c5b96547caa2.svg";
export { ForwardRef as ReactComponent };